import { Avatar, Badge, Box, Flex, HStack, ModalCloseButton, SimpleGrid, Text } from "@chakra-ui/react";

import RateSummaryCard from "./RateSummaryCard";

const SUMMARY_CARDS = [
  { key: "base", label: "평균 주간", color: "gray.900" },
  { key: "night", label: "평균 야간", color: "purple.600" },
  { key: "daySpecial", label: "평균 주간 특근", color: "orange.500" },
  { key: "nightSpecial", label: "평균 야간 특근", color: "blue.600" },
];

export default function RateEditModalHeader({ summary, user }) {
  return (
    <Box
      bg="linear-gradient(135deg, #F0FFF4 0%, #ECFEF8 48%, #EBF8FF 100%)"
      px={{ base: 4, md: 7 }}
      py={6}
    >
      <Flex justify="space-between" align="flex-start" gap={4}>
        <HStack spacing={4} align="flex-start">
          <Avatar name={user?.user_name} size="lg" bg="green.500" color="white" flexShrink={0} />
          <Box>
            <HStack spacing={2} mb={1}>
              <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="900" color="gray.900">
                {user?.user_name} 일급 상세
              </Text>
              <Badge colorScheme="green" borderRadius="full" px={3}>
                {summary.places}개 근무지
              </Badge>
            </HStack>
            <Text fontSize="sm" color="gray.600">
              근무지별 주간·야간·주간 특근·야간 특근 평균을 확인합니다.
            </Text>
          </Box>
        </HStack>
        <ModalCloseButton position="static" />
      </Flex>

      <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={3} mt={5}>
        {SUMMARY_CARDS.map((item) => (
          <RateSummaryCard
            key={item.key}
            label={item.label}
            value={summary[item.key]}
            color={item.color}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
}
